<div class="slider-authors" *ngIf="!placeholder">
  <div class="slider-component">
    <div class="slider-authors__top">
      <div class="slider-component__header">
        <h2 tabindex="0" [class.clickable]="preview">{{ (title | translate) || '&nbsp;' }}</h2>

        <div class="slider-component__header__actions" *ngIf="authors?.length > 0">
          <div class="actions-wrapper">
            <button mat-flat-button class="only-icon hide-tablet" (click)="viewAll()">
              <span class="odilo-icon">navigate_next</span>
            </button>
            <button mat-flat-button class="accent transparent hide-mobile" (click)="viewAll()">
              {{ 'general.viewMore' | translate }}
            </button>
            <button
              mat-flat-button
              class="only-icon hide-mobile"
              [matMenuTriggerFor]="actionsMenu"
              [attr.aria-label]="'general.viewMore' | translate">
              <span class="odilo-icon">more_vertical</span>
            </button>
            <mat-menu #actionsMenu="matMenu">
              <button mat-menu-item (click)="addAuthors()">
                <span class="odilo-icon">add</span>
                {{ 'lists.addAuthors' | translate }}
              </button>
              <button mat-menu-item (click)="showUnfollowedAuthorsDialog.set(true)">
                <span class="odilo-icon">delete</span>
                {{ 'general.removeAll' | translate }}
              </button>
            </mat-menu>
          </div>
        </div>
      </div>

      <div class="slider-component__subheader">
        <div class="slider-component__subheader">
          <span>{{ authors.length }} {{ (authors?.length === 1 ? 'general.item' : 'general.items') | translate }}</span>
        </div>
      </div>

      <div class="slider-component__empty" *ngIf="authors?.length === 0">
        <div class="slider-component__empty__content">
          <span class="hide-mobile">{{ 'lists.noAuthors' | translate }}</span>
          <button mat-flat-button class="accent transparent" (click)="addAuthors()">
            {{ 'lists.addAuthors' | translate }}
          </button>
        </div>
      </div>
    </div>

    <opac-swiper [configuration]="swiperConfig">
      <opac-swiper-item *ngFor="let author of authors; let i = index" class="author-slider">
        <opac-author-card-item [name]="author.author" [backgroundColor]="author.color" [backgroundVectorImageIndex]="i"></opac-author-card-item>
      </opac-swiper-item>
    </opac-swiper>
  </div>
</div>

<div class="wrapper" *ngIf="placeholder">
  <div class="slider-component">
    <div class="slider-component__title">
      <h2>&nbsp;</h2>
    </div>

    <opac-swiper [configuration]="swiperPlaceholderConfig">
      <opac-swiper-item *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
        <div class="placeholder-cover">
          <div class="item__img">
            <img src="/assets/cover_white_215.png" />
          </div>
        </div>
      </opac-swiper-item>
    </opac-swiper>
  </div>
</div>

<opac-confirmation-dialog
  [acceptLabel]="'general.confirm'"
  [cancelLabel]="'general.cancel'"
  [open]="showUnfollowedAuthorsDialog()"
  [title]="'lists.unfollowAll' | translate"
  (accept)="unfollowAllAuthors()"
  (cancel)="showUnfollowedAuthorsDialog.set(false)">
  <p>{{ 'lists.unfollowAllAuthors' | translate }}</p>
</opac-confirmation-dialog>